<svg
  width="119"
  height="43"
  viewBox="0 0 119 43"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M109 33.0002L96.6151 18.3455C92.0996 13.0022 85.9751 10.0002 79.5891 10L9 9.99999"
    stroke="url(#paint0_linear_713_2359)"
    stroke-opacity="0.3"
    stroke-miterlimit="10"
  />
  <path
    d="M109 33.0002L96.6151 18.3455C92.0996 13.0022 85.9751 10.0002 79.5891 10L9 9.99999"
    stroke="url(#paint1_linear_713_2359)"
    stroke-miterlimit="10"
  />
  <g filter="url(#filter0_f_713_2359)">
    <path
      d="M109 33.0002L96.6151 18.3455C92.0996 13.0022 85.9751 10.0002 79.5891 10L9 9.99999"
      stroke="url(#paint2_linear_713_2359)"
      stroke-miterlimit="10"
    />
  </g>
  <defs>
    <filter
      id="filter0_f_713_2359"
      x="0"
      y="0.499992"
      width="118.382"
      height="41.8229"
      filterUnits="userSpaceOnUse"
      color-interpolation-filters="sRGB"
    >
      <feFlood flood-opacity="0" result="BackgroundImageFix" />
      <feBlend
        mode="normal"
        in="SourceGraphic"
        in2="BackgroundImageFix"
        result="shape"
      />
      <feGaussianBlur
        stdDeviation="4.5"
        result="effect1_foregroundBlur_713_2359"
      />
    </filter>
    <linearGradient
      id="paint0_linear_713_2359"
      x1="9"
      y1="10"
      x2="111.179"
      y2="27.8598"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.14082" stop-color="#FF3434" stop-opacity="0" />
      <stop offset="0.528091" stop-color="#FF3434" />
      <stop offset="0.667521" stop-color="#FF3434" stop-opacity="0.89" />
      <stop offset="1" stop-color="#FF3434" stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint1_linear_713_2359"
      x1="9"
      y1="10"
      x2="111.179"
      y2="27.8598"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.14082" stop-color="#FF3434" stop-opacity="0" />
      <stop offset="0.528091" stop-color="#FF3434" />
      <stop offset="0.667521" stop-color="#FF3434" stop-opacity="0.89" />
      <stop offset="1" stop-color="#FF3434" stop-opacity="0" />
    </linearGradient>
    <linearGradient
      id="paint2_linear_713_2359"
      x1="9"
      y1="10"
      x2="111.179"
      y2="27.8598"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0.14082" stop-color="#FF3434" stop-opacity="0" />
      <stop offset="0.528091" stop-color="#FF3434" />
      <stop offset="0.667521" stop-color="#FF3434" stop-opacity="0.89" />
      <stop offset="1" stop-color="#FF3434" stop-opacity="0" />
    </linearGradient>
  </defs>
</svg>
